import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';

import * as actions from '../actions';
import * as c from '../constant';
import Content from './Content';

const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'PAID', value: 'PAID' },
];

function ApplicationContainer({
  match,
  getList,
  list,
  isLoading,
  pager,
  history,
}) {
  const [filter, setFilter] = React.useState({
    module_type: 'MISC_FEE_LP',
    transaction_status: '',
    year: '',
    q: '',
  });

  const handleOnChangeFilter =
    (key) =>
    ({ value }) =>
      setFilter({
        ...filter,
        [key]: value,
      });

  const handleSearch = (e) => {
    setFilter({
      ...filter,
      q: e.target.value,
    });
  };

  const handleResetFilter = () =>
    setFilter((prevFilter) => ({
      ...prevFilter,
      q: '',
      transaction_status: '',
      year: '',
    }));

  useEffect(() => {
    getList(filter);
  }, [filter]);

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <Route
          path={`${match.path}/:id?`}
          render={({ match: { params } }) => (
            <GenericListPair
              statusOptions={statusOptions}
              moduleName="Applications"
              getData={getList}
              setParams={filter}
              setKeyword={handleSearch}
              setYearFilter={handleOnChangeFilter('year')}
              setStatusFilter={handleOnChangeFilter('transaction_status')}
              resetStatusFilter={handleResetFilter}
              sideBarFilter
              status={_.get(filter, 'transaction_status') || ''}
              keyword={_.get(filter, 'q') || ''}
              keywordPlaceholder="Search Transaction..."
              pathName={`${match.path}/:id?`}
              listName="Application"
              label="Application List"
              renderItem={(item) => (
                <div className="px-3 py-3">
                  <div className="transaction-list-company">
                    {_.get(item, 'attributes.name_format')}
                  </div>
                  <h4 className="mt-1 mb-0 transaction-list-name">
                    {_.get(item, 'attributes.mobile_number_format') || ''}
                  </h4>
                </div>
              )}
              isLoading={isLoading}
              selected={params.id}
              data={list}
              dataPager={pager}
              handleSelectRow={(data) => {
                history.push(`${match.url}/${_.get(data, 'id')}`);
              }}
              renderContent={() => (
                <React.Fragment>
                  <Switch>
                    <Route
                      path={`${match.path}/:misc_fee_id?`}
                      render={() => <Content list={list} />}
                    />
                  </Switch>
                  <Route
                    path={`${match.path}/:misc_fee_id?`}
                    render={() =>
                      !params.misc_fee_id && list.length > 0 ? (
                        <Redirect to={`${match.url}/${_.get(list, '0.id')}`} />
                      ) : null
                    }
                  />
                </React.Fragment>
              )}
            />
          )}
        />
      </div>
    </React.Fragment>
  );
}

ApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainer);
